import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { FiltrosProducaoRetornoService } from '../../../../filters/filtros-producaoretorno.service';

@Component({
  selector: 'app-painelproducaoretorno',
  templateUrl: './painelproducaoretorno.component.html',
  styleUrl: './painelproducaoretorno.component.css',
  providers: [DatePipe]
})
export class PainelproducaoretornoComponent {
  rangeDates!: string;
  instanciaSelecionada!: string;
  loading: boolean = false;

  constructor(
    private filtrosProducaoRetorno: FiltrosProducaoRetornoService,
    private datePipe: DatePipe
  ){}

  onDateChange(event: any){
    this.filtrosProducaoRetorno.alteraDataInicio(this.getDataPipeTransForm(this.rangeDates[0]));
    this.filtrosProducaoRetorno.alteraDataFim(this.getDataPipeTransForm(this.rangeDates[1]));
  }

  onInstanciaChange(event: any){
    this.filtrosProducaoRetorno.alteraInstancia(this.instanciaSelecionada);
  }

  getDataPipeTransForm(data: string): string | "" {
    return this.datePipe.transform(data,'yyyy-MM-dd') || "";
  }
}
